export const TOOLBAR_GAP_OPTIONS = {
  XS: null,
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
};
